import { c as _c } from "react/compiler-runtime";
import { BuildContextProvider } from '../../providers';
import SixTileCarousel from './SixTileCarousel';
import type { Tile6UpProps, TilesProps } from './types';
import './Tile6UpTips.scss';
export default function Tile6UpTips(t0) {
  const $ = _c(6);
  const {
    tiles,
    variant
  } = t0;
  let t1;
  if ($[0] !== tiles) {
    t1 = tiles.slice(0, 5).map(_temp);
    $[0] = tiles;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      560: {
        perView: 2.5,
        gap: 8
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== variant) {
    t3 = <BuildContextProvider><SixTileCarousel className="tile6up-tips" alignText="center" data-testid="six-tile-tips" tiles={t1} breakpoints={t2} variant={variant} overrideDefaultClass={true} /></BuildContextProvider>;
    $[3] = t1;
    $[4] = variant;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp(tile) {
  return {
    internalTitle: tile.internalTitle,
    title: tile.title,
    image: tile.image,
    sysId: tile.sysId
  };
}